// src/components/dashbords/CursorRuler/CursorRuler.tsx
import React, { useState, useEffect, useCallback, useRef } from "react";
import "./CursorRuler.css";

interface CursorRulerProps {
  enabled?: boolean;
}

export const CursorRuler: React.FC<CursorRulerProps> = ({
  enabled = false,
}) => {
  const [isVisible, setIsVisible] = useState(enabled);
  const [isDragging, setIsDragging] = useState(false);
  const rulerRef = useRef<HTMLDivElement>(null);
  const positionRef = useRef<number>(50); // храним позицию в ref (без ререндера)

  // Включение/выключение линейки
  const toggleRuler = useCallback(() => {
    setIsVisible((prev) => !prev);
  }, []);

  // Обработка движения мыши при перетаскивании
  const handleMouseMove = useCallback((e: MouseEvent) => {
    if (!isDragging || !rulerRef.current) return;

    const container = rulerRef.current.parentElement;
    if (!container) return;

    const containerRect = container.getBoundingClientRect();
    const newX = e.clientX - containerRect.left;
    const percent = Math.max(0, Math.min(100, (newX / containerRect.width) * 100));

    positionRef.current = percent;
    // Двигаем напрямую через DOM — без ререндера!
    rulerRef.current.style.left = `${percent}%`;
  }, [isDragging]);

  // Окончание перетаскивания
  const handleMouseUp = useCallback(() => {
    setIsDragging(false);
  }, []);

  // Начало перетаскивания на линии
  const handleRulerMouseDown = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  }, []);

  // Глобальные слушатели для перетаскивания
  useEffect(() => {
    if (isDragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
      return () => {
        window.removeEventListener("mousemove", handleMouseMove);
        window.removeEventListener("mouseup", handleMouseUp);
      };
    }
  }, [isDragging, handleMouseMove, handleMouseUp]);

  // Сброс при отключении
  useEffect(() => {
    if (!isVisible) {
      positionRef.current = 50;
    }
  }, [isVisible]);

  return (
    <>
      {/* Кнопка включения/выключения */}
      <button
        className={`cursor-ruler-toggle ${isVisible ? "active" : ""}`}
        onClick={toggleRuler}
        title={isVisible ? "Отключить линейку" : "Включить линейку"}
      >
        <span className="ruler-icon">📏</span>
      </button>

      {/* Вертикальная линия */}
      {isVisible && (
        <div
          ref={rulerRef}
          className="cursor-ruler"
          style={{ left: `${positionRef.current}%` }}
          onMouseDown={handleRulerMouseDown}
        >
          <div className="ruler-line" />
          <div className="ruler-handle">
            <span>↕</span>
          </div>
        </div>
      )}
    </>
  );
};
